import styled from 'styled-components';
import breakpoints from '@repo/ui-components/breakpoints';
import sharedStyles from '@repo/ui-components/styles';

export default styled.hr`
  display: block;
  border: none;
  color: ${props => props.theme?.colors?.background};
  height: 2px;
  background: none;
  background: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(25, 25, 25, 0) 5%,
    ${props => props.theme?.colors?.border} 50%,
    rgba(0, 0, 0, 0) 95%,
    rgba(25, 25, 25, 0) 100%
  );
  margin: ${sharedStyles.spacing['spacing-lg']} 0;
  @media screen and (min-width: ${breakpoints.md}) {
    margin: ${sharedStyles.spacing['spacing-1xl']} 0;
  }
`;
